import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Select } from 'antd';
import PropTypes from 'prop-types';
import { UNASSIGNED_TASKS_ID } from '../helpers/constants';

const AddEmployeeModal = ({
    isModalVisible,
    handleModalClose,
    handleFormSubmit,
    housekeepersByTab,
    users,
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [form] = Form.useForm();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
           
            setIsLoading(false);
        };

        fetchData();
    }, [housekeepersByTab]);

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());


    const modifiedUsers = users
    .filter(
        (user) =>
            user._id !== UNASSIGNED_TASKS_ID &&
            !housekeepersByTab.some(
                (housekeeper) => housekeeper.id === user._id
            )
    )
    .map((user) => ({
        value: `${user._id}_${user.fullName}`,
        label: user.fullName,
    }));

    return (
        <>
            <Modal
                loading={!users || isLoading}
                footer={null}
                open={isModalVisible}
                title='Add New Employee'
                onCancel={handleModalClose}
            >
                <Form form={form} key='newEmployee' onFinish={handleFormSubmit}>
                    <Form.Item
                        name='userId'
                        rules={[
                            {
                                required: true,
                                message: 'Please select!',
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            options={modifiedUsers}
                            filterOption={filterOption}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType='submit' type='primary'>
                            Add New Employee
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

AddEmployeeModal.propTypes = {
    handleFormSubmit: PropTypes.func.isRequired,
    isModalVisible: PropTypes.bool.isRequired,
    handleModalClose: PropTypes.func.isRequired,
    housekeepersByTab: PropTypes.array.isRequired,
    users: PropTypes.array
};

export default AddEmployeeModal;
